// Student case-study viewer. The reading itself is done by SecurePdfReader: view-only, no
// download, print or copy (see components/SecurePdfReader.jsx).
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import SideBar from '../usercomponents/SideBar';
import TopNavBar from '../usercomponents/TopNavBar';
import Footer from '../usercomponents/Footer';
import SecurePdfReader from '../components/SecurePdfReader';

function StudentViewCaseStudy() {
  const location = useLocation();
  const navigate = useNavigate();
  const { bookTitle, pdfUrl, courseName } = location.state || {};

  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb mb-4">
            <ul className="d-flex align-items-center gap-2 list-unstyled">
              <li><Link to="/dashboard" className="text-gray-200 text-15 hover-text-main-600 text-decoration-none">Home</Link></li>
              <li><span className="text-gray-500 d-flex align-items-center"><i className="ph ph-caret-right" /></span></li>
              <li><Link to="/student-case-studies" className="text-gray-200 text-15 hover-text-main-600 text-decoration-none">Case Studies</Link></li>
              <li><span className="text-gray-500 d-flex align-items-center"><i className="ph ph-caret-right" /></span></li>
              <li><span className="text-main-600 text-15">View PDF</span></li>
            </ul>
          </div>

          {!bookTitle || !pdfUrl ? (
            <div className="alert alert-danger">
              <h4>Case study not found</h4>
              <p>Please go back and open it from the Case Studies list.</p>
              <button type="button" onClick={() => navigate(-1)} className="btn btn-primary">Go Back</button>
            </div>
          ) : (
            <div className="card">
              <div className="card-header">
                <h4 className="mb-0">{bookTitle}</h4>
                {courseName && <p className="text-muted mb-0">Course: {courseName}</p>}
              </div>
              <div className="card-body">
                <SecurePdfReader pdfUrl={pdfUrl} sessionKey="studentSession" onBack={() => navigate(-1)} />
              </div>
            </div>
          )}
        </div>
        <Footer />
      </div>
    </>
  );
}

export default StudentViewCaseStudy;
